export const GET_ALL_MATRIX_DATA = "GET_ALL_MATRIX_DATA";
export const SEARCH_ALL_MATRIX_USER = "SEARCH_ALL_MATRIX_USER";
export const GET_ALL_DEPARTMENT = "GET_ALL_DEPARTMENT";
export const GET_ALL_DEPARTMENT_TEAMS = "GET_ALL_DEPARTMENT_TEAMS";
export const GET_ALL_MATRIX_MATCHING_DATA = "GET_ALL_MATRIX_MATCHING_DATA";
export const MATRIX_START_COMPARE_DATA = "MATRIX_START_COMPARE_DATA";
export const MATRIX_START_COMPARE_LEFT_DATA = "MATRIX_START_COMPARE_LEFT_DATA";
export const MATRIX_START_COMPARE_RIGHT_DATA = "MATRIX_START_COMPARE_RIGHT_DATA";
export const MATRIX_SEARCH_SKILLS = "MATRIX_SEARCH_SKILLS";
